import React, {useState, useEffect} from 'react'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext'


export default function DispatchedExams(){
    const {user} = useAuth()
    const schoolID = user.scId
    const [testGroups, setTestGroups] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [studentsWithExams, setStudentsWithExams] = useState([])

    async function fetchTestGroups(){
        try{
            console.log(" i dispath er skole: " + schoolID)
            const result = await apiClient.get('/api/testgroup/getall', 
                {params: {schoolID : schoolID}}
            )
            setTestGroups(result.data)
        }catch(e){
            console.log("fejl ved fetch af test groups")
            console.log(e)
        }
    }

    async function fetchStudentsWithExams(){
        try{
            const result = await apiClient.get('/api/testgroup/getstudentswithexams',
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
            setStudentsWithExams(result.data)
            console.log("Det lykkedes med at få studerner ")
            console.log(result?.data?.rowCount)

        }catch(e){
            console.log(" error in getting students with exams")
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchTestGroups()
        fetchStudentsWithExams()
    }, [currentTestGroup])

    async function handleDownload(filename){
        try{
            const res = await apiClient.get('/api/downloadfile', {
                params: {filename},
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(res.data)
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        }catch(e){
            console.log("fejl ved download af fil")
            console.log(e)
        }
    }
    return(
        <div className ="panel-container">
            <div className="panel">
                <select onChange={(e)=>setCurrentTestGroup(testGroups.find(s=> s.id === parseInt(e.target.value)))}>
                    <option key="0" value="0">Ingen prøvegruppe valgt</option>
                    {testGroups.map(testGroup =>(
                        <option key={testGroup.id} value={testGroup.id}>{testGroup.navn}</option>
                    ))}
                </select>
                <span>
                    <b>Testgruppe: </b> {currentTestGroup?.navn}
                </span>

                {studentsWithExams.length > 0 && (
                    <table className="censor-table" style={{marginTop: '16px'}}>
                        <thead>
                            <tr>
                                <th>Kursist nummer:</th>
                                <th>Fornavn(e):</th>
                                <th>Efternavn:</th>
                                <th>Skriftlig prøve</th>
                                <th style={{width: '80px'}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentsWithExams.map(student => (
                                <tr key={student.id}>
                                    <td>{student.id}</td>
                                    <td>{student.fornavne}</td>
                                    <td>{student.efternavn}</td>
                                    <td>{student.examupload_filename}</td>
                                    <td>
                                        <button onClick={() => handleDownload(student.examupload_filename)}>Download</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>    )
}